import { FilterExprSchema } from '@hostingportal/schemas'
import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { z } from 'zod'
import { PANEL_TYPES } from '../../../shell/panel-state'
// Register the subscription panel plus the foreign panels the subscriptions grid
// cross-references (company / contact / product) so those open in place without
// leaving the subscriptions list.
import '../../../modules/companies/register-panels'
import '../../../modules/contacts/register-panels'
import '../../../modules/products/register-panels'
import '../../../modules/subscriptions/register-panels'
import { SubscriptionsView } from '../../../modules/subscriptions/subscriptions-view'

const subscriptionsSearchSchema = z.object({
  q: z.string().optional(),
  page: z.coerce.number().int().min(1).optional(),
  pageSize: z.coerce.number().int().min(1).max(200).optional(),
  panel: z.enum(PANEL_TYPES).optional(),
  panelId: z.string().optional(),
  panelMode: z.enum(['create']).optional(),
  companyId: z.string().optional(),
  sortField: z.string().optional(),
  sortDir: z.enum(['asc', 'desc']).optional(),
  // AND/OR filter expression (Zod-validated).
  filter: FilterExprSchema.optional(),
  // Quick-filter values (the top-bar chips), URL-backed + Zod-validated.
  quick: FilterExprSchema.optional(),
})

/** The subscriptions surface: the per-instance "contract product" grid. */
export const Route = createFileRoute('/_authed/subscriptions/')({
  validateSearch: subscriptionsSearchSchema,
  component: SubscriptionsRoute,
})

function SubscriptionsRoute() {
  const search = Route.useSearch()
  const navigate = useNavigate()
  return (
    <SubscriptionsView
      search={search}
      setSearch={(patch) =>
        navigate({
          to: '.',
          search: ((prev: Record<string, unknown>) => ({ ...prev, ...patch })) as never,
          replace: true,
        })
      }
    />
  )
}
